import React from 'react';
import './MusicConsentModal.css';

const MusicConsentModal = ({ onStartMusic }) => {
  return (
    <div className="music-consent-overlay">
      <div className="music-consent-modal">
        <div className="modal-content">
          <h2 className="modal-title">🎵 歡迎！Welcome!</h2>
          <p className="modal-message">
            遊戲設有背景音樂，以提升你的視聽體驗。<br/>
            This game features background music to enhance your audiovisual experience.
          </p>
          <button 
            className="start-music-btn"
            onClick={onStartMusic}
          >
            開始遊戲並播放音樂<br/>
            Play the soundtrack and start the game.
          </button>
        </div>
      </div>
    </div>
  );
};

export default MusicConsentModal; 